import React, { useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { Button, Grid, Header, Image } from 'semantic-ui-react';
import PhotoWidgetDropzone from './PhotoWidgetDropzone';
import PhotoWidgetCropper from './PhotoWidgetCropper';
//import { Cropper } from 'react-cropper';

interface Props {
    uploadPhoto: (file: Blob) => void; //. >> takes a file of type Blob and return  void
    isLoading: boolean;
}

function PhotoUploadWidget(prpos: Props) {
    const [files, setFiles] = useState<any>([]); //'n
    const [cropper, setCropper] = useState<Cropper>();

    useEffect(() => { //' To revoke in momery file.preview
        return () => {
            files.forEach((file: any) => URL.revokeObjectURL(file.preview));
        }
    }, [files])

    function onCrop() {
        if(cropper) {
            cropper.getCroppedCanvas().toBlob(blob => {
                console.log(blob);
                prpos.uploadPhoto(blob!);
            });
        }
    }

    return (
        <Grid>
            <Grid.Column width={1} />
            <Grid.Column width={4}>
                <Header content='Step 1 - Add Photo' sub color='teal' style={{paddingBottom: '15px'}} />
                <PhotoWidgetDropzone setFiles={setFiles} />
            </Grid.Column>

            <Grid.Column width={1} />
            <Grid.Column width={4}>
                <Header content='Step 2 - Resize image' sub color='teal' style={{paddingBottom: '15px'}} />
                {files && files.length > 0 && (
                    // <Image src={files[0].preview} />
                    <PhotoWidgetCropper imagePreview={files[0].preview} setCropper={setCropper} />
                )}
            </Grid.Column>

            <Grid.Column width={1} />
            <Grid.Column width={4}>
                <Header content='Step 3 - Preview & Upload' sub color='teal' style={{paddingBottom: '15px'}} />
                {files && files.length > 0 && (
                    <>
                        <div className='img-preview' style={{ minHeight: 200, overflow: 'hidden' }} />
                        <Button.Group widths={2}>
                            <Button onClick={onCrop} positive icon='check' loading={prpos.isLoading} />
                            <Button onClick={() => setFiles([]) } icon='close' disabled={prpos.isLoading} />
                        </Button.Group>
                    </>
                )}
            </Grid.Column>
        </Grid>
    )
}

export default observer(PhotoUploadWidget);

